
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @generated SignedSource<<b387d58755674457ae4f39adf063ec37>>
 * @relayHash 4d36c161a002817ebf0a774bd870c3f0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e
const $52181a874b01b0e6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LookAndFeel",
                    "kind": "LinkedField",
                    "name": "lookAndFeel",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentLookAndFeel",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScreenLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "screen",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "background"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundColor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundImage"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundPosition"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundSize"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundRepeat"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundOrigin"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundClip"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundAttachment"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "backgroundBlendMode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MainLayoutQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4d36c161a002817ebf0a774bd870c3f0",
            "id": "e774a160f409825c4d6c3237444559164a7757efd676ad8ac90163b199ff341e",
            "metadata": {},
            "name": "MainLayoutQuery",
            "operationKind": "query",
            "text": "query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id,lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode}}}}}"
        }
    };
}();
$52181a874b01b0e6$var$node.hash = "de3e636b8d3cf59cd103bdc7552ea849";
var $52181a874b01b0e6$export$2e2bcd8739ae039 = $52181a874b01b0e6$var$node;



var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");


var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $5ZPtT = parcelRequire("5ZPtT");

/**
 * @generated SignedSource<<aee3d452e700222c207ed3413b38e9d4>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47
const $4a82a81af9c5e51c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b1c5bff520163b91e48e77e975abc312",
            "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
            "metadata": {},
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "operationKind": "query",
            "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
        }
    };
}();
$4a82a81af9c5e51c$var$node.hash = "5414d0003b526de29b97ae12c29148ab";
var $4a82a81af9c5e51c$export$2e2bcd8739ae039 = $4a82a81af9c5e51c$var$node;






var $55fM8 = parcelRequire("55fM8");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");





var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $cozmU.useRef)(null);
    const allAppsLoaded = (0, $cozmU.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const presetTimeoutConfig = (0, $1xpoY.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $1xpoY.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $4a82a81af9c5e51c$export$2e2bcd8739ae039), {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "web-panel-location"
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");








var $gXfti = parcelRequire("gXfti");





















var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $cozmU.useRef)(null);
    const lastLoggedForgePageBannerHeightRef = (0, $cozmU.useRef)(undefined);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $cozmU.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(([entry])=>{
            if (entry) {
                const height = entry.target.clientHeight;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.documentElement.style.setProperty('--forge-page-banner-height', `${height}px`);
                if (lastLoggedForgePageBannerHeightRef.current !== height) {
                    lastLoggedForgePageBannerHeightRef.current = height;
                    (0, $gXfti.addUFOCustomData)({
                        fixedForgePageBannerWrapperHeight: height
                    });
                }
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: height
                    }
                } : undefined;
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};









var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $lzgC6 = parcelRequire("lzgC6");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $lzgC6.default)()(class ReturnToMobileComponent extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_4FKVYE5zaO _2uo31fDMqu _2fwxA5DIqT"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: this.getSwitchToMobileHref(),
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", (event)=>{
            event.preventDefault();
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
        $796a872a5806d472$var$_defineProperty(this, "getSwitchToMobileHref", ()=>{
            const { getQueryParams: getQueryParams } = this.props;
            const queryParams = getQueryParams();
            const url = new URL(window.location.href);
            if (queryParams.desktop === 'true') url.searchParams.delete('desktop');
             // Resulting URL is same page, non-desktop override
            return url.toString();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $cozmU.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");





var $9wGTI = parcelRequire("9wGTI");





var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");











function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v3.0.2 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $8wW9d = parcelRequire("8wW9d");





var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    // Instrument the presence of non-content 3P background-script apps so their
    // keys are folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('background-script', forgeModules.map((app)=>app?.id));
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_3iDTPbYbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }));
const $b7830f7e8969acd1$var$PageBannerForgeAppWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
})(({ app: app, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attributes: {
            appId: (0, $8a9Dm.getAppId)(app)
        },
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.PageBannerForgeApp), {
        app: app,
        ...props
    }))); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    } // Instrument the presence of non-content 3P page-banner apps so their keys are
    // folded into the page-load `connectAppKeys` telemetry.
    (0, $8wW9d.recordNonContentAppKeys)('page-banner', forgeModules.map((app)=>app?.id)); // A shared preset height is only safe for one Custom UI banner; UI Kit does not use an iframe.
    const shouldPresetHeight = forgeModules.length === 1 && forgeModules[0]?.properties?.resource != null && forgeModules[0]?.properties?.render !== 'native';
    const pageBannerProps = {
        shouldPresetHeight: shouldPresetHeight,
        extensionData: {
            type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
            ...contentId ? {
                content: {
                    id: contentId,
                    type: (0, $hIaUw.getContentType)(routeName),
                    subtype: isLivePage ? 'live' : null
                }
            } : {},
            ...spaceKey || spaceAlias ? {
                space: {
                    id: spaceId,
                    key: spaceKey || spaceAlias
                }
            } : {}
        }
    }; // This is the experiment's single exposure point: only users with an eligible banner app should
    // be enrolled. MainLayout uses a non-exposing read to coordinate its wrapper structure.
    if (forgeModules.length > 0 && (0, $6mKj3.expValEquals)('confluence_fix_page_banner_render', 'isEnabled', true)) return forgeModules.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7830f7e8969acd1$var$PageBannerForgeAppWithErrorBoundary, {
            key: `${(0, $8a9Dm.getAppId)(app)}:${contentId ?? ''}`,
            app: app,
            ...pageBannerProps
        }));
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            ...pageBannerProps
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
});


const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_3iDTPbvLZJ",
    hidePanel: "_3iDTPbYbGa"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_23rrnH647S _0aFT5v1qpb _3TGfC9HnLE _39xV02N91d _2XsHFMPgdg _4eDzxwTTQh",
    addMinWidth: "_4ouGXIELL6"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_3iDTPbYbGa _42Yu6BaZ2J _39xV02N91d _1mT5xdy1CL _0KLXrulfZc _3OE6xY1nKm _1EqgXluI1V",
    showPanel: "_3iDTPbvLZJ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _0KLXrulfZc _24h04i2Njc _1RrJLiBwqQ _4kiQYAIZbP _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS = [
    (0, $hrAmX.BannerStateContainer)
];
const $4e0d0b830c02a893$var$getForgePageBannerPresetHeight = ()=>{
    try {
        const config = JSON.parse((0, $1xpoY.default).getString('confluence_forge_banner_preset_height', ''));
        return typeof config.presetHeight === 'number' ? config.presetHeight : 0;
    } catch  {
        return 0;
    }
};
const $4e0d0b830c02a893$var$MainLayoutInnerContent = ({ enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children, isLivePage: isLivePage, ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport, renderServerPlaceholder: renderServerPlaceholder })=>{
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, true, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $cozmU.useState)(false);
    const shouldRenderATLGeneralWebPanel = shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport;
    const shouldOmitATLFooterWebPanel = isEdit || isLivePage || ommitComponentsNotNeededForPdfExport || renderServerPlaceholder;
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    const forgePageBannerInitialHeight = $4e0d0b830c02a893$var$getForgePageBannerPresetHeight();
    const shouldUseForgePageBannerInitialHeight = forgePageBannerInitialHeight > 5;
    (0, $cozmU.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0jFU0VjOtr"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const persistentForgePageBannerExtensionPoint = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": isForgePageBannerFixed ? 'fixed-forge-page-banner-wrapper-compiled' : 'forge-page-banner-wrapper-compiled',
        ref: fixedForgePageBannerRef,
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            isForgePageBannerFixed && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            isForgePageBannerFixed && !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel'],
            !isForgePageBannerFixed && $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            !isForgePageBannerFixed && shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), isForgePageBannerFixed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            "_0jFU0VNIFp"
        ])
    })); // MainLayout cannot tell whether this page has an eligible banner app. Read the assignment without
    // exposing here; RenderForgeAppsAsPageBanners records exposure after extension discovery.
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation -- exposure is recorded in RenderForgeAppsAsPageBanners after confirming eligibility
    const ForgePageBannerExtensionPoint = (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_fix_page_banner_render', 'isEnabled', true) ? persistentForgePageBannerExtensionPoint : isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            "_0jFU0VNIFp"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "forge-page-banner-wrapper-compiled",
        ...shouldUseForgePageBannerInitialHeight ? {
            style: {
                minHeight: `${forgePageBannerInitialHeight}px`
            }
        } : {},
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null));
    const mainLayoutContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            "confluence-main-content"
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldRenderATLGeneralWebPanel && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _313842dnbC _24h04i2Njc _2uxTLTZSoF _1mT5xdRAKS _39xV02N91d _3iDTPbQ4SZ _4kiQYAZqHV"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle
        }, children))), !shouldOmitATLFooterWebPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $hekY6.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER),
        // server rendered, invalidating the hydrated DOM. ATL_GENERAL passes `cache-first`
        // for the same reason.
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `.confluence-main-content .cp-container [role='dialog'] { z-index: 350; }`
        }
    }), mainLayoutContent) : null;
};
const $4e0d0b830c02a893$export$80006b81bf20e108 = (props)=>{
    const { isViewPage: isViewPage = false, isEdit: isEdit } = props;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const browserLocation = typeof globalThis.window?.location !== 'undefined' ? globalThis.window.location : undefined;
    const isPdfExport = browserLocation !== undefined && Boolean((0, $1NBp8.PDF_EXPORT_PAGE).match(browserLocation.pathname));
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let webPanelBatchLocations = [];
    if (!ommitComponentsNotNeededForPdfExport) {
        if (isViewPage || isEdit) webPanelBatchLocations = [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ];
    }
    const shouldRenderWebPanelBatchProvider = webPanelBatchLocations.length > 0 && (0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$var$MainLayoutInnerContent, {
        ...props,
        isLivePage: isLivePage,
        ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport,
        renderServerPlaceholder: renderServerPlaceholder
    });
    return shouldRenderWebPanelBatchProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Z1sw.WebPanelLocationBatchProvider), {
        locations: webPanelBatchLocations
    }, content) : content;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $cozmU.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $cozmU.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5ZPtT.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content);
};


const $a171d54840e7d827$var$MainLayoutQuery = (0, $52181a874b01b0e6$export$2e2bcd8739ae039);
const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $cozmU.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $jMyy4.useQueryInterop)($a171d54840e7d827$var$MainLayoutQuery, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage,
        __callerPackage__: "main-layout"
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("4tS20"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("4tS20", function(module, exports) {

let $3433c8576b6cae8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3433c8576b6cae8d$var$load("kT6dz"),
    $3433c8576b6cae8d$var$load("iY1NC"),
    $3433c8576b6cae8d$var$load("lCFwv"),
    $3433c8576b6cae8d$var$load("1LQYR"),
    $3433c8576b6cae8d$var$load("3YRzU"),
    $3433c8576b6cae8d$var$load("glcJK"),
    $3433c8576b6cae8d$var$load("5SpB1"),
    $3433c8576b6cae8d$var$load("bPC3R"),
    $3433c8576b6cae8d$var$load("bHb1X"),
    $3433c8576b6cae8d$var$load("dHQc0"),
    $3433c8576b6cae8d$var$load("iTOzX"),
    $3433c8576b6cae8d$var$load("ipkwd"),
    $3433c8576b6cae8d$var$load("4Gdnz"),
    $3433c8576b6cae8d$var$load("4UAag"),
    $3433c8576b6cae8d$var$load("zUKwV"),
    $3433c8576b6cae8d$var$load("fUeur"),
    $3433c8576b6cae8d$var$load("6gMrU"),
    $3433c8576b6cae8d$var$load("iECXC"),
    $3433c8576b6cae8d$var$load("fq1gG"),
    $3433c8576b6cae8d$var$load("eShF9"),
    $3433c8576b6cae8d$var$load("6wr18"),
    $3433c8576b6cae8d$var$load("jxLUH"),
    $3433c8576b6cae8d$var$load("8GpcP"),
    $3433c8576b6cae8d$var$load("5nbvZ"),
    $3433c8576b6cae8d$var$load("g8ky2"),
    $3433c8576b6cae8d$var$load("hohnS"),
    $3433c8576b6cae8d$var$load("dkoen"),
    $3433c8576b6cae8d$var$load("8eGGc"),
    $3433c8576b6cae8d$var$load("bWtlo"),
    $3433c8576b6cae8d$var$load("eW2qV"),
    $3433c8576b6cae8d$var$load("ezYRV"),
    $3433c8576b6cae8d$var$load("Mp0pM"),
    $3433c8576b6cae8d$var$load("agVmZ"),
    $3433c8576b6cae8d$var$load("aEiTV"),
    $3433c8576b6cae8d$var$load("VXbA1"),
    $3433c8576b6cae8d$var$load("1qlDN"),
    $3433c8576b6cae8d$var$load("1yVM6"),
    $3433c8576b6cae8d$var$load("ea3NB"),
    $3433c8576b6cae8d$var$load("bjgFk"),
    $3433c8576b6cae8d$var$load("hLKNw"),
    $3433c8576b6cae8d$var$load("6ijE0"),
    $3433c8576b6cae8d$var$load("7xWDo"),
    $3433c8576b6cae8d$var$load("3Pk7X"),
    $3433c8576b6cae8d$var$load("aLbuU"),
    $3433c8576b6cae8d$var$load("jIqhU"),
    $3433c8576b6cae8d$var$load("lya9W"),
    $3433c8576b6cae8d$var$load("ffEVr"),
    $3433c8576b6cae8d$var$load("lEedB"),
    $3433c8576b6cae8d$var$load("cL90P"),
    $3433c8576b6cae8d$var$load("fob67"),
    $3433c8576b6cae8d$var$load("Wowvf"),
    $3433c8576b6cae8d$var$load("4g6rd"),
    $3433c8576b6cae8d$var$load("2D1RT"),
    $3433c8576b6cae8d$var$load("gGPOl"),
    $3433c8576b6cae8d$var$load("5sZTx"),
    $3433c8576b6cae8d$var$load("deTdD"),
    $3433c8576b6cae8d$var$load("1JeTB"),
    $3433c8576b6cae8d$var$load("hhss7"),
    $3433c8576b6cae8d$var$load("7EorR"),
    $3433c8576b6cae8d$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $isuYJ = parcelRequire("isuYJ");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $7Ndnw = parcelRequire("7Ndnw");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, skipSpaceDetail: t3, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const skipSpaceDetail = t3 === undefined ? false : t3;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    let t4;
    if ($[0] !== skipSpaceDetail) {
        t4 = {
            skip: skipSpaceDetail
        };
        $[0] = skipSpaceDetail;
        $[1] = t4;
    } else t4 = $[1];
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, t4);
    let t5;
    if ($[2] !== moduleType) {
        t5 = ()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType];
        $[2] = moduleType;
        $[3] = t5;
    } else t5 = $[3];
    const [ssrExtensionResult] = (0, $cozmU.useState)(t5);
    let t6;
    if ($[4] !== cloudId || $[5] !== contentId || $[6] !== locale || $[7] !== moduleType || $[8] !== queryOptions || $[9] !== resolvedAttachmentId || $[10] !== returnBlockedExtensions || $[11] !== skipQuery || $[12] !== spaceContextOnly || $[13] !== spaceKey) {
        t6 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[4] = cloudId;
        $[5] = contentId;
        $[6] = locale;
        $[7] = moduleType;
        $[8] = queryOptions;
        $[9] = resolvedAttachmentId;
        $[10] = returnBlockedExtensions;
        $[11] = skipQuery;
        $[12] = spaceContextOnly;
        $[13] = spaceKey;
        $[14] = t6;
    } else t6 = $[14];
    const options = t6;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t7;
    let t8;
    if ($[15] !== extsError || $[16] !== spaceError) {
        t7 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t8 = [
            extsError,
            spaceError
        ];
        $[15] = extsError;
        $[16] = spaceError;
        $[17] = t7;
        $[18] = t8;
    } else {
        t7 = $[17];
        t8 = $[18];
    }
    (0, $cozmU.useEffect)(t7, t8);
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
        let t9;
        if ($[19] !== ssrExtensionResult.error || $[20] !== ssrExtensionResult.extensions) {
            t9 = {
                extensions: ssrExtensionResult.extensions,
                loading: false,
                error: ssrExtensionResult.error
            };
            $[19] = ssrExtensionResult.error;
            $[20] = ssrExtensionResult.extensions;
            $[21] = t9;
        } else t9 = $[21];
        return t9;
    }
    let t9;
    if ($[22] !== extsData || $[23] !== extsError || $[24] !== extsLoading) {
        t9 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[22] = extsData;
        $[23] = extsError;
        $[24] = extsLoading;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, skipSpaceDetail: skipSpaceDetail = false, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey, {
        skip: skipSpaceDetail
    });
    const [ssrExtensionResult] = (0, $cozmU.useState)(()=>window.__SSR_FORGE_EXTENSIONS__?.[moduleType]);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    if (!skipQuery && extsLoading && ssrExtensionResult !== undefined && ssrExtensionResult.context !== undefined && ssrExtensionResult.context.spaceKey === spaceKey && ssrExtensionResult.context.includeHidden === returnBlockedExtensions && ssrExtensionResult.context.spaceContextOnly === Boolean(spaceContextOnly) && (spaceContextOnly || ssrExtensionResult.context.contentId === contentId) && (moduleType === (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE) || moduleType === (0, $7Ndnw.FORGE_MODULE_BYLINE) && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) return {
        extensions: ssrExtensionResult.extensions,
        loading: false,
        error: ssrExtensionResult.error
    };
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $isuYJ.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(18);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2, skip: t3 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    const skip = t3 === undefined ? false : t3;
    let t4;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t4 = {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== skip) {
        t5 = skip ? {
            skip: true
        } : {};
        $[5] = skip;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== t4 || $[8] !== t5) {
        t6 = {
            variables: t4,
            ...t5
        };
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const options = t6;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    if (skip) {
        let t7;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                loading: false
            };
            $[10] = t7;
        } else t7 = $[10];
        return t7;
    }
    let t7;
    if ($[11] !== data || $[12] !== includeSpaceTypeSettings) {
        t7 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[11] = data;
        $[12] = includeSpaceTypeSettings;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== error || $[15] !== loading || $[16] !== t7) {
        t8 = {
            loading: loading,
            data: t7,
            error: error
        };
        $[14] = error;
        $[15] = loading;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("4NX9d", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $cozmU.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars($8facebd0ecb5e0ee$var$_temp);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("6yagU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3Ap09 = parcelRequire("3Ap09");


var $dAzRS = parcelRequire("dAzRS");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null;
} : ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children } = t0;
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    let t1;
    if ($[0] !== closeAllPanels) {
        t1 = ()=>{
            closeAllPanels();
        };
        $[0] = closeAllPanels;
        $[1] = t1;
    } else t1 = $[1];
    const onPreviewPanelOpen = t1;
    let t2;
    if ($[2] !== closeOnlyPreviewPanel) {
        t2 = ()=>{
            closeOnlyPreviewPanel();
        };
        $[2] = closeOnlyPreviewPanel;
        $[3] = t2;
    } else t2 = $[3];
    const onPreviewPanelClose = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== onPreviewPanelClose || $[7] !== onPreviewPanelOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose,
            parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
        }, t3, children);
        $[5] = children;
        $[6] = onPreviewPanelClose;
        $[7] = onPreviewPanelOpen;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $cozmU.useCallback)(()=>{
        /*
    Any time a Preview Panel is opened in Confluence, we want to close all
    non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
    */ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $cozmU.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
    	Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
    	next panel are different, we want to close the previous panel before opening the new one. In order to
    	do this we need to pass the preview panel api
    */ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Ap09.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dAzRS.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    let t0;
    let t1;
    if ($[0] !== closeOnlyPreviewPanel || $[1] !== location) {
        t0 = ()=>{
            const currentLocationKey = `${location.pathname}${location.search}`;
            const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
            if (currentLocationKey !== previousLocationKey) {
                closeOnlyPreviewPanel();
                previousLocation.current = location;
            }
        };
        t1 = [
            location,
            closeOnlyPreviewPanel
        ];
        $[0] = closeOnlyPreviewPanel;
        $[1] = location;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
} : ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $KDAt0.useLocation)();
    const previousLocation = (0, $cozmU.useRef)(location);
    (0, $cozmU.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $lRhY3 = parcelRequire("lRhY3");


var $3Ap09 = parcelRequire("3Ap09");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] !== hideObjectSidebar) {
        t0 = ()=>{
            window.dispatchEvent(new Event("closeGlobalSidebar"));
            hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const closeObjectSidebar = t0;
    let t1;
    if ($[2] !== close || $[3] !== context?.state?.panel) {
        t1 = (onClose)=>{
            if (context?.state?.panel) close(onClose);
        };
        $[2] = close;
        $[3] = context?.state?.panel;
        $[4] = t1;
    } else t1 = $[4];
    const closeOnlyPreviewPanel = t1;
    let t2;
    if ($[5] !== closeAll || $[6] !== closeObjectSidebar) {
        t2 = ()=>{
            closeAll();
            closeObjectSidebar();
        };
        $[5] = closeAll;
        $[6] = closeObjectSidebar;
        $[7] = t2;
    } else t2 = $[7];
    const closeAllPanels = t2;
    let t3;
    if ($[8] !== closeAllPanels || $[9] !== closeOnlyPreviewPanel) {
        t3 = {
            closeAllPanels: closeAllPanels,
            closeOnlyPreviewPanel: closeOnlyPreviewPanel
        };
        $[8] = closeAllPanels;
        $[9] = closeOnlyPreviewPanel;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        // eslint-disable-next-line @typescript-eslint/no-floating-promises -- Sidebar close is intentionally fire-and-forget
        hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, timeout: timeout, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            timeout: (0, $9wGTI.fg)('confluence_experience_tracker_timeout') ? timeout : undefined,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$1764bc361f317144 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dQS92",
    name: "AttachmentActionForgeApp",
    loader: async ()=>(await (parcelRequire("d1ZCp"))).AttachmentActionForgeApp
});

const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("eHhN9"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("203uQ"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("2AdQz"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("eZA6R"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("hPe5C"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("jDOcd"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("3smEr"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("fDv6K"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("dLZxU"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("cMFzX"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("iyWzA"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("dZD8d"))).PageBannerForgeApp
});
module.exports["AttachmentActionForgeApp"] = $02976f123c8f8e25$export$1764bc361f317144;
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("d1ZCp", function(module, exports) {

let $97cb2a82b437ca53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $97cb2a82b437ca53$var$load("hUbK8"),
    $97cb2a82b437ca53$var$load("LWh5V"),
    $97cb2a82b437ca53$var$load("eNXrl"),
    $97cb2a82b437ca53$var$load("9cVML"),
    $97cb2a82b437ca53$var$load("1Gr4q"),
    $97cb2a82b437ca53$var$load("aGpvE"),
    $97cb2a82b437ca53$var$load("fqrmE"),
    $97cb2a82b437ca53$var$load("7SteV"),
    $97cb2a82b437ca53$var$load("7G12e"),
    $97cb2a82b437ca53$var$load("30b92"),
    $97cb2a82b437ca53$var$load("4AElS"),
    $97cb2a82b437ca53$var$load("ksOjm"),
    $97cb2a82b437ca53$var$load("jAsJw"),
    $97cb2a82b437ca53$var$load("jisiR"),
    $97cb2a82b437ca53$var$load("icVON"),
    $97cb2a82b437ca53$var$load("aLwQm"),
    $97cb2a82b437ca53$var$load("bPC3R"),
    $97cb2a82b437ca53$var$load("bHb1X"),
    $97cb2a82b437ca53$var$load("90SZm"),
    $97cb2a82b437ca53$var$load("crfrC"),
    $97cb2a82b437ca53$var$load("4x9Jx"),
    $97cb2a82b437ca53$var$load("kHXvF"),
    $97cb2a82b437ca53$var$load("ea3NB"),
    $97cb2a82b437ca53$var$load("59hV4"),
    $97cb2a82b437ca53$var$load("iTOzX"),
    $97cb2a82b437ca53$var$load("ipkwd"),
    $97cb2a82b437ca53$var$load("fuOfV"),
    $97cb2a82b437ca53$var$load("jL1Ke"),
    $97cb2a82b437ca53$var$load("5MQ0D"),
    $97cb2a82b437ca53$var$load("cvcNg"),
    $97cb2a82b437ca53$var$load("iZR3N"),
    $97cb2a82b437ca53$var$load("jXM1T"),
    $97cb2a82b437ca53$var$load("6wr18"),
    $97cb2a82b437ca53$var$load("4N1MY"),
    $97cb2a82b437ca53$var$load("ffEVr"),
    $97cb2a82b437ca53$var$load("4Gdnz"),
    $97cb2a82b437ca53$var$load("4UAag"),
    $97cb2a82b437ca53$var$load("fwbNS"),
    $97cb2a82b437ca53$var$load("zUKwV"),
    $97cb2a82b437ca53$var$load("fUeur"),
    $97cb2a82b437ca53$var$load("6gMrU"),
    $97cb2a82b437ca53$var$load("h4Nf7"),
    $97cb2a82b437ca53$var$load("Wowvf"),
    $97cb2a82b437ca53$var$load("4g6rd"),
    $97cb2a82b437ca53$var$load("5sZTx"),
    $97cb2a82b437ca53$var$load("deTdD"),
    $97cb2a82b437ca53$var$load("1JeTB"),
    $97cb2a82b437ca53$var$load("hhss7"),
    $97cb2a82b437ca53$var$load("1sii7"),
    $97cb2a82b437ca53$var$load("lnKog"),
    $97cb2a82b437ca53$var$load("kT6dz"),
    $97cb2a82b437ca53$var$load("aAWLw"),
    $97cb2a82b437ca53$var$load("7EorR"),
    $97cb2a82b437ca53$var$load("fJ8Kj")
]).then(()=>parcelRequire('2L9yO'));

});

parcelRegister("eHhN9", function(module, exports) {

let $ab32e1e621e889a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab32e1e621e889a8$var$load("hUbK8"),
    $ab32e1e621e889a8$var$load("LWh5V"),
    $ab32e1e621e889a8$var$load("eNXrl"),
    $ab32e1e621e889a8$var$load("9cVML"),
    $ab32e1e621e889a8$var$load("1Gr4q"),
    $ab32e1e621e889a8$var$load("aGpvE"),
    $ab32e1e621e889a8$var$load("fqrmE"),
    $ab32e1e621e889a8$var$load("7SteV"),
    $ab32e1e621e889a8$var$load("7G12e"),
    $ab32e1e621e889a8$var$load("30b92"),
    $ab32e1e621e889a8$var$load("4AElS"),
    $ab32e1e621e889a8$var$load("ksOjm"),
    $ab32e1e621e889a8$var$load("jAsJw"),
    $ab32e1e621e889a8$var$load("jisiR"),
    $ab32e1e621e889a8$var$load("icVON"),
    $ab32e1e621e889a8$var$load("aLwQm"),
    $ab32e1e621e889a8$var$load("bPC3R"),
    $ab32e1e621e889a8$var$load("bHb1X"),
    $ab32e1e621e889a8$var$load("90SZm"),
    $ab32e1e621e889a8$var$load("crfrC"),
    $ab32e1e621e889a8$var$load("4x9Jx"),
    $ab32e1e621e889a8$var$load("kHXvF"),
    $ab32e1e621e889a8$var$load("ea3NB"),
    $ab32e1e621e889a8$var$load("59hV4"),
    $ab32e1e621e889a8$var$load("iTOzX"),
    $ab32e1e621e889a8$var$load("ipkwd"),
    $ab32e1e621e889a8$var$load("fuOfV"),
    $ab32e1e621e889a8$var$load("jL1Ke"),
    $ab32e1e621e889a8$var$load("5MQ0D"),
    $ab32e1e621e889a8$var$load("cvcNg"),
    $ab32e1e621e889a8$var$load("iZR3N"),
    $ab32e1e621e889a8$var$load("jXM1T"),
    $ab32e1e621e889a8$var$load("6wr18"),
    $ab32e1e621e889a8$var$load("4N1MY"),
    $ab32e1e621e889a8$var$load("ffEVr"),
    $ab32e1e621e889a8$var$load("4Gdnz"),
    $ab32e1e621e889a8$var$load("4UAag"),
    $ab32e1e621e889a8$var$load("fwbNS"),
    $ab32e1e621e889a8$var$load("zUKwV"),
    $ab32e1e621e889a8$var$load("fUeur"),
    $ab32e1e621e889a8$var$load("6gMrU"),
    $ab32e1e621e889a8$var$load("h4Nf7"),
    $ab32e1e621e889a8$var$load("Wowvf"),
    $ab32e1e621e889a8$var$load("4g6rd"),
    $ab32e1e621e889a8$var$load("5sZTx"),
    $ab32e1e621e889a8$var$load("deTdD"),
    $ab32e1e621e889a8$var$load("1JeTB"),
    $ab32e1e621e889a8$var$load("hhss7"),
    $ab32e1e621e889a8$var$load("1sii7"),
    $ab32e1e621e889a8$var$load("lnKog"),
    $ab32e1e621e889a8$var$load("kT6dz"),
    $ab32e1e621e889a8$var$load("aAWLw"),
    $ab32e1e621e889a8$var$load("7EorR"),
    $ab32e1e621e889a8$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("203uQ", function(module, exports) {

let $174e4b2b7102edea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $174e4b2b7102edea$var$load("hUbK8"),
    $174e4b2b7102edea$var$load("LWh5V"),
    $174e4b2b7102edea$var$load("eNXrl"),
    $174e4b2b7102edea$var$load("9cVML"),
    $174e4b2b7102edea$var$load("1Gr4q"),
    $174e4b2b7102edea$var$load("aGpvE"),
    $174e4b2b7102edea$var$load("fqrmE"),
    $174e4b2b7102edea$var$load("7SteV"),
    $174e4b2b7102edea$var$load("7G12e"),
    $174e4b2b7102edea$var$load("30b92"),
    $174e4b2b7102edea$var$load("4AElS"),
    $174e4b2b7102edea$var$load("ksOjm"),
    $174e4b2b7102edea$var$load("jAsJw"),
    $174e4b2b7102edea$var$load("jisiR"),
    $174e4b2b7102edea$var$load("icVON"),
    $174e4b2b7102edea$var$load("aLwQm"),
    $174e4b2b7102edea$var$load("bPC3R"),
    $174e4b2b7102edea$var$load("bHb1X"),
    $174e4b2b7102edea$var$load("90SZm"),
    $174e4b2b7102edea$var$load("crfrC"),
    $174e4b2b7102edea$var$load("4x9Jx"),
    $174e4b2b7102edea$var$load("kHXvF"),
    $174e4b2b7102edea$var$load("ea3NB"),
    $174e4b2b7102edea$var$load("59hV4"),
    $174e4b2b7102edea$var$load("iTOzX"),
    $174e4b2b7102edea$var$load("ipkwd"),
    $174e4b2b7102edea$var$load("fuOfV"),
    $174e4b2b7102edea$var$load("jL1Ke"),
    $174e4b2b7102edea$var$load("5MQ0D"),
    $174e4b2b7102edea$var$load("cvcNg"),
    $174e4b2b7102edea$var$load("iZR3N"),
    $174e4b2b7102edea$var$load("jXM1T"),
    $174e4b2b7102edea$var$load("6wr18"),
    $174e4b2b7102edea$var$load("4N1MY"),
    $174e4b2b7102edea$var$load("ffEVr"),
    $174e4b2b7102edea$var$load("4Gdnz"),
    $174e4b2b7102edea$var$load("4UAag"),
    $174e4b2b7102edea$var$load("fwbNS"),
    $174e4b2b7102edea$var$load("zUKwV"),
    $174e4b2b7102edea$var$load("fUeur"),
    $174e4b2b7102edea$var$load("6gMrU"),
    $174e4b2b7102edea$var$load("h4Nf7"),
    $174e4b2b7102edea$var$load("Wowvf"),
    $174e4b2b7102edea$var$load("4g6rd"),
    $174e4b2b7102edea$var$load("5sZTx"),
    $174e4b2b7102edea$var$load("deTdD"),
    $174e4b2b7102edea$var$load("1JeTB"),
    $174e4b2b7102edea$var$load("hhss7"),
    $174e4b2b7102edea$var$load("1sii7"),
    $174e4b2b7102edea$var$load("lnKog"),
    $174e4b2b7102edea$var$load("kT6dz"),
    $174e4b2b7102edea$var$load("aAWLw"),
    $174e4b2b7102edea$var$load("7EorR"),
    $174e4b2b7102edea$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("2AdQz", function(module, exports) {

let $1e19af49dcf84ba0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1e19af49dcf84ba0$var$load("hUbK8"),
    $1e19af49dcf84ba0$var$load("LWh5V"),
    $1e19af49dcf84ba0$var$load("eNXrl"),
    $1e19af49dcf84ba0$var$load("9cVML"),
    $1e19af49dcf84ba0$var$load("1Gr4q"),
    $1e19af49dcf84ba0$var$load("aGpvE"),
    $1e19af49dcf84ba0$var$load("fqrmE"),
    $1e19af49dcf84ba0$var$load("7SteV"),
    $1e19af49dcf84ba0$var$load("7G12e"),
    $1e19af49dcf84ba0$var$load("30b92"),
    $1e19af49dcf84ba0$var$load("4AElS"),
    $1e19af49dcf84ba0$var$load("ksOjm"),
    $1e19af49dcf84ba0$var$load("jAsJw"),
    $1e19af49dcf84ba0$var$load("jisiR"),
    $1e19af49dcf84ba0$var$load("icVON"),
    $1e19af49dcf84ba0$var$load("aLwQm"),
    $1e19af49dcf84ba0$var$load("bPC3R"),
    $1e19af49dcf84ba0$var$load("bHb1X"),
    $1e19af49dcf84ba0$var$load("90SZm"),
    $1e19af49dcf84ba0$var$load("crfrC"),
    $1e19af49dcf84ba0$var$load("4x9Jx"),
    $1e19af49dcf84ba0$var$load("kHXvF"),
    $1e19af49dcf84ba0$var$load("ea3NB"),
    $1e19af49dcf84ba0$var$load("59hV4"),
    $1e19af49dcf84ba0$var$load("iTOzX"),
    $1e19af49dcf84ba0$var$load("ipkwd"),
    $1e19af49dcf84ba0$var$load("fuOfV"),
    $1e19af49dcf84ba0$var$load("jL1Ke"),
    $1e19af49dcf84ba0$var$load("5MQ0D"),
    $1e19af49dcf84ba0$var$load("cvcNg"),
    $1e19af49dcf84ba0$var$load("iZR3N"),
    $1e19af49dcf84ba0$var$load("jXM1T"),
    $1e19af49dcf84ba0$var$load("6wr18"),
    $1e19af49dcf84ba0$var$load("4N1MY"),
    $1e19af49dcf84ba0$var$load("ffEVr"),
    $1e19af49dcf84ba0$var$load("4Gdnz"),
    $1e19af49dcf84ba0$var$load("4UAag"),
    $1e19af49dcf84ba0$var$load("fwbNS"),
    $1e19af49dcf84ba0$var$load("zUKwV"),
    $1e19af49dcf84ba0$var$load("fUeur"),
    $1e19af49dcf84ba0$var$load("6gMrU"),
    $1e19af49dcf84ba0$var$load("h4Nf7"),
    $1e19af49dcf84ba0$var$load("Wowvf"),
    $1e19af49dcf84ba0$var$load("4g6rd"),
    $1e19af49dcf84ba0$var$load("5sZTx"),
    $1e19af49dcf84ba0$var$load("deTdD"),
    $1e19af49dcf84ba0$var$load("1JeTB"),
    $1e19af49dcf84ba0$var$load("hhss7"),
    $1e19af49dcf84ba0$var$load("1sii7"),
    $1e19af49dcf84ba0$var$load("lnKog"),
    $1e19af49dcf84ba0$var$load("kT6dz"),
    $1e19af49dcf84ba0$var$load("aAWLw"),
    $1e19af49dcf84ba0$var$load("7EorR"),
    $1e19af49dcf84ba0$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("eZA6R", function(module, exports) {

let $aea2c5d597b6c5b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aea2c5d597b6c5b8$var$load("zUKwV"),
    $aea2c5d597b6c5b8$var$load("fUeur"),
    $aea2c5d597b6c5b8$var$load("hUbK8"),
    $aea2c5d597b6c5b8$var$load("9cVML"),
    $aea2c5d597b6c5b8$var$load("1Gr4q"),
    $aea2c5d597b6c5b8$var$load("aGpvE"),
    $aea2c5d597b6c5b8$var$load("fqrmE"),
    $aea2c5d597b6c5b8$var$load("7SteV"),
    $aea2c5d597b6c5b8$var$load("7G12e"),
    $aea2c5d597b6c5b8$var$load("4AElS"),
    $aea2c5d597b6c5b8$var$load("ksOjm"),
    $aea2c5d597b6c5b8$var$load("jAsJw"),
    $aea2c5d597b6c5b8$var$load("jisiR"),
    $aea2c5d597b6c5b8$var$load("icVON"),
    $aea2c5d597b6c5b8$var$load("aLwQm"),
    $aea2c5d597b6c5b8$var$load("bPC3R"),
    $aea2c5d597b6c5b8$var$load("bHb1X"),
    $aea2c5d597b6c5b8$var$load("4x9Jx"),
    $aea2c5d597b6c5b8$var$load("kHXvF"),
    $aea2c5d597b6c5b8$var$load("ea3NB"),
    $aea2c5d597b6c5b8$var$load("iTOzX"),
    $aea2c5d597b6c5b8$var$load("ipkwd"),
    $aea2c5d597b6c5b8$var$load("cvcNg"),
    $aea2c5d597b6c5b8$var$load("iZR3N"),
    $aea2c5d597b6c5b8$var$load("jXM1T"),
    $aea2c5d597b6c5b8$var$load("6wr18"),
    $aea2c5d597b6c5b8$var$load("4N1MY"),
    $aea2c5d597b6c5b8$var$load("ffEVr"),
    $aea2c5d597b6c5b8$var$load("4Gdnz"),
    $aea2c5d597b6c5b8$var$load("4UAag"),
    $aea2c5d597b6c5b8$var$load("1sii7"),
    $aea2c5d597b6c5b8$var$load("6gMrU"),
    $aea2c5d597b6c5b8$var$load("h4Nf7"),
    $aea2c5d597b6c5b8$var$load("Wowvf"),
    $aea2c5d597b6c5b8$var$load("4g6rd"),
    $aea2c5d597b6c5b8$var$load("5sZTx"),
    $aea2c5d597b6c5b8$var$load("deTdD"),
    $aea2c5d597b6c5b8$var$load("1JeTB"),
    $aea2c5d597b6c5b8$var$load("hhss7"),
    $aea2c5d597b6c5b8$var$load("kT6dz"),
    $aea2c5d597b6c5b8$var$load("aAWLw"),
    $aea2c5d597b6c5b8$var$load("7EorR"),
    $aea2c5d597b6c5b8$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("hPe5C", function(module, exports) {

let $cfa220ff5c626c03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cfa220ff5c626c03$var$load("zUKwV"),
    $cfa220ff5c626c03$var$load("fUeur"),
    $cfa220ff5c626c03$var$load("hUbK8"),
    $cfa220ff5c626c03$var$load("9cVML"),
    $cfa220ff5c626c03$var$load("1Gr4q"),
    $cfa220ff5c626c03$var$load("aGpvE"),
    $cfa220ff5c626c03$var$load("fqrmE"),
    $cfa220ff5c626c03$var$load("7SteV"),
    $cfa220ff5c626c03$var$load("7G12e"),
    $cfa220ff5c626c03$var$load("4AElS"),
    $cfa220ff5c626c03$var$load("ksOjm"),
    $cfa220ff5c626c03$var$load("jAsJw"),
    $cfa220ff5c626c03$var$load("jisiR"),
    $cfa220ff5c626c03$var$load("icVON"),
    $cfa220ff5c626c03$var$load("aLwQm"),
    $cfa220ff5c626c03$var$load("bPC3R"),
    $cfa220ff5c626c03$var$load("bHb1X"),
    $cfa220ff5c626c03$var$load("4x9Jx"),
    $cfa220ff5c626c03$var$load("kHXvF"),
    $cfa220ff5c626c03$var$load("ea3NB"),
    $cfa220ff5c626c03$var$load("iTOzX"),
    $cfa220ff5c626c03$var$load("ipkwd"),
    $cfa220ff5c626c03$var$load("cvcNg"),
    $cfa220ff5c626c03$var$load("iZR3N"),
    $cfa220ff5c626c03$var$load("jXM1T"),
    $cfa220ff5c626c03$var$load("6wr18"),
    $cfa220ff5c626c03$var$load("4N1MY"),
    $cfa220ff5c626c03$var$load("ffEVr"),
    $cfa220ff5c626c03$var$load("4Gdnz"),
    $cfa220ff5c626c03$var$load("4UAag"),
    $cfa220ff5c626c03$var$load("1sii7"),
    $cfa220ff5c626c03$var$load("6gMrU"),
    $cfa220ff5c626c03$var$load("h4Nf7"),
    $cfa220ff5c626c03$var$load("Wowvf"),
    $cfa220ff5c626c03$var$load("4g6rd"),
    $cfa220ff5c626c03$var$load("5sZTx"),
    $cfa220ff5c626c03$var$load("deTdD"),
    $cfa220ff5c626c03$var$load("1JeTB"),
    $cfa220ff5c626c03$var$load("hhss7"),
    $cfa220ff5c626c03$var$load("kT6dz"),
    $cfa220ff5c626c03$var$load("aAWLw"),
    $cfa220ff5c626c03$var$load("7EorR"),
    $cfa220ff5c626c03$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("jDOcd", function(module, exports) {

let $e4c898bc04ea554a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4c898bc04ea554a$var$load("zUKwV"),
    $e4c898bc04ea554a$var$load("fUeur"),
    $e4c898bc04ea554a$var$load("hUbK8"),
    $e4c898bc04ea554a$var$load("9cVML"),
    $e4c898bc04ea554a$var$load("1Gr4q"),
    $e4c898bc04ea554a$var$load("aGpvE"),
    $e4c898bc04ea554a$var$load("fqrmE"),
    $e4c898bc04ea554a$var$load("7SteV"),
    $e4c898bc04ea554a$var$load("7G12e"),
    $e4c898bc04ea554a$var$load("4AElS"),
    $e4c898bc04ea554a$var$load("ksOjm"),
    $e4c898bc04ea554a$var$load("jAsJw"),
    $e4c898bc04ea554a$var$load("jisiR"),
    $e4c898bc04ea554a$var$load("icVON"),
    $e4c898bc04ea554a$var$load("aLwQm"),
    $e4c898bc04ea554a$var$load("bPC3R"),
    $e4c898bc04ea554a$var$load("bHb1X"),
    $e4c898bc04ea554a$var$load("4x9Jx"),
    $e4c898bc04ea554a$var$load("kHXvF"),
    $e4c898bc04ea554a$var$load("ea3NB"),
    $e4c898bc04ea554a$var$load("iTOzX"),
    $e4c898bc04ea554a$var$load("ipkwd"),
    $e4c898bc04ea554a$var$load("cvcNg"),
    $e4c898bc04ea554a$var$load("iZR3N"),
    $e4c898bc04ea554a$var$load("jXM1T"),
    $e4c898bc04ea554a$var$load("6wr18"),
    $e4c898bc04ea554a$var$load("4N1MY"),
    $e4c898bc04ea554a$var$load("ffEVr"),
    $e4c898bc04ea554a$var$load("4Gdnz"),
    $e4c898bc04ea554a$var$load("4UAag"),
    $e4c898bc04ea554a$var$load("1sii7"),
    $e4c898bc04ea554a$var$load("6gMrU"),
    $e4c898bc04ea554a$var$load("h4Nf7"),
    $e4c898bc04ea554a$var$load("Wowvf"),
    $e4c898bc04ea554a$var$load("4g6rd"),
    $e4c898bc04ea554a$var$load("5sZTx"),
    $e4c898bc04ea554a$var$load("deTdD"),
    $e4c898bc04ea554a$var$load("1JeTB"),
    $e4c898bc04ea554a$var$load("hhss7"),
    $e4c898bc04ea554a$var$load("kT6dz"),
    $e4c898bc04ea554a$var$load("aAWLw"),
    $e4c898bc04ea554a$var$load("7EorR"),
    $e4c898bc04ea554a$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("3smEr", function(module, exports) {

let $28458eac2fd5a5df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28458eac2fd5a5df$var$load("zUKwV"),
    $28458eac2fd5a5df$var$load("fUeur"),
    $28458eac2fd5a5df$var$load("hUbK8"),
    $28458eac2fd5a5df$var$load("9cVML"),
    $28458eac2fd5a5df$var$load("1Gr4q"),
    $28458eac2fd5a5df$var$load("aGpvE"),
    $28458eac2fd5a5df$var$load("fqrmE"),
    $28458eac2fd5a5df$var$load("7SteV"),
    $28458eac2fd5a5df$var$load("7G12e"),
    $28458eac2fd5a5df$var$load("4AElS"),
    $28458eac2fd5a5df$var$load("ksOjm"),
    $28458eac2fd5a5df$var$load("jAsJw"),
    $28458eac2fd5a5df$var$load("jisiR"),
    $28458eac2fd5a5df$var$load("icVON"),
    $28458eac2fd5a5df$var$load("aLwQm"),
    $28458eac2fd5a5df$var$load("bPC3R"),
    $28458eac2fd5a5df$var$load("bHb1X"),
    $28458eac2fd5a5df$var$load("4x9Jx"),
    $28458eac2fd5a5df$var$load("kHXvF"),
    $28458eac2fd5a5df$var$load("ea3NB"),
    $28458eac2fd5a5df$var$load("iTOzX"),
    $28458eac2fd5a5df$var$load("ipkwd"),
    $28458eac2fd5a5df$var$load("cvcNg"),
    $28458eac2fd5a5df$var$load("iZR3N"),
    $28458eac2fd5a5df$var$load("jXM1T"),
    $28458eac2fd5a5df$var$load("6wr18"),
    $28458eac2fd5a5df$var$load("4N1MY"),
    $28458eac2fd5a5df$var$load("ffEVr"),
    $28458eac2fd5a5df$var$load("4Gdnz"),
    $28458eac2fd5a5df$var$load("4UAag"),
    $28458eac2fd5a5df$var$load("6gMrU"),
    $28458eac2fd5a5df$var$load("h4Nf7"),
    $28458eac2fd5a5df$var$load("Wowvf"),
    $28458eac2fd5a5df$var$load("4g6rd"),
    $28458eac2fd5a5df$var$load("5sZTx"),
    $28458eac2fd5a5df$var$load("deTdD"),
    $28458eac2fd5a5df$var$load("1JeTB"),
    $28458eac2fd5a5df$var$load("hhss7"),
    $28458eac2fd5a5df$var$load("1sii7"),
    $28458eac2fd5a5df$var$load("lnKog"),
    $28458eac2fd5a5df$var$load("kT6dz"),
    $28458eac2fd5a5df$var$load("aAWLw"),
    $28458eac2fd5a5df$var$load("7EorR"),
    $28458eac2fd5a5df$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("fDv6K", function(module, exports) {

let $b622a0ead8779005$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b622a0ead8779005$var$load("hUbK8"),
    $b622a0ead8779005$var$load("9cVML"),
    $b622a0ead8779005$var$load("1Gr4q"),
    $b622a0ead8779005$var$load("aGpvE"),
    $b622a0ead8779005$var$load("fqrmE"),
    $b622a0ead8779005$var$load("7SteV"),
    $b622a0ead8779005$var$load("7G12e"),
    $b622a0ead8779005$var$load("30b92"),
    $b622a0ead8779005$var$load("4AElS"),
    $b622a0ead8779005$var$load("ksOjm"),
    $b622a0ead8779005$var$load("jAsJw"),
    $b622a0ead8779005$var$load("jisiR"),
    $b622a0ead8779005$var$load("icVON"),
    $b622a0ead8779005$var$load("aLwQm"),
    $b622a0ead8779005$var$load("bPC3R"),
    $b622a0ead8779005$var$load("bHb1X"),
    $b622a0ead8779005$var$load("90SZm"),
    $b622a0ead8779005$var$load("crfrC"),
    $b622a0ead8779005$var$load("4x9Jx"),
    $b622a0ead8779005$var$load("kHXvF"),
    $b622a0ead8779005$var$load("ea3NB"),
    $b622a0ead8779005$var$load("59hV4"),
    $b622a0ead8779005$var$load("iTOzX"),
    $b622a0ead8779005$var$load("ipkwd"),
    $b622a0ead8779005$var$load("fuOfV"),
    $b622a0ead8779005$var$load("jL1Ke"),
    $b622a0ead8779005$var$load("5MQ0D"),
    $b622a0ead8779005$var$load("cvcNg"),
    $b622a0ead8779005$var$load("iZR3N"),
    $b622a0ead8779005$var$load("jXM1T"),
    $b622a0ead8779005$var$load("6wr18"),
    $b622a0ead8779005$var$load("4N1MY"),
    $b622a0ead8779005$var$load("ffEVr"),
    $b622a0ead8779005$var$load("4Gdnz"),
    $b622a0ead8779005$var$load("4UAag"),
    $b622a0ead8779005$var$load("fwbNS"),
    $b622a0ead8779005$var$load("zUKwV"),
    $b622a0ead8779005$var$load("fUeur"),
    $b622a0ead8779005$var$load("6gMrU"),
    $b622a0ead8779005$var$load("h4Nf7"),
    $b622a0ead8779005$var$load("Wowvf"),
    $b622a0ead8779005$var$load("4g6rd"),
    $b622a0ead8779005$var$load("5sZTx"),
    $b622a0ead8779005$var$load("deTdD"),
    $b622a0ead8779005$var$load("1JeTB"),
    $b622a0ead8779005$var$load("hhss7"),
    $b622a0ead8779005$var$load("1sii7"),
    $b622a0ead8779005$var$load("lnKog"),
    $b622a0ead8779005$var$load("kT6dz"),
    $b622a0ead8779005$var$load("aAWLw"),
    $b622a0ead8779005$var$load("7EorR"),
    $b622a0ead8779005$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("dLZxU", function(module, exports) {

let $a06f67dce68e1116$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a06f67dce68e1116$var$load("hUbK8"),
    $a06f67dce68e1116$var$load("9cVML"),
    $a06f67dce68e1116$var$load("1Gr4q"),
    $a06f67dce68e1116$var$load("aGpvE"),
    $a06f67dce68e1116$var$load("fqrmE"),
    $a06f67dce68e1116$var$load("7SteV"),
    $a06f67dce68e1116$var$load("7G12e"),
    $a06f67dce68e1116$var$load("30b92"),
    $a06f67dce68e1116$var$load("4AElS"),
    $a06f67dce68e1116$var$load("ksOjm"),
    $a06f67dce68e1116$var$load("jAsJw"),
    $a06f67dce68e1116$var$load("jisiR"),
    $a06f67dce68e1116$var$load("icVON"),
    $a06f67dce68e1116$var$load("aLwQm"),
    $a06f67dce68e1116$var$load("bPC3R"),
    $a06f67dce68e1116$var$load("bHb1X"),
    $a06f67dce68e1116$var$load("90SZm"),
    $a06f67dce68e1116$var$load("crfrC"),
    $a06f67dce68e1116$var$load("4x9Jx"),
    $a06f67dce68e1116$var$load("kHXvF"),
    $a06f67dce68e1116$var$load("ea3NB"),
    $a06f67dce68e1116$var$load("59hV4"),
    $a06f67dce68e1116$var$load("iTOzX"),
    $a06f67dce68e1116$var$load("ipkwd"),
    $a06f67dce68e1116$var$load("fuOfV"),
    $a06f67dce68e1116$var$load("jL1Ke"),
    $a06f67dce68e1116$var$load("5MQ0D"),
    $a06f67dce68e1116$var$load("cvcNg"),
    $a06f67dce68e1116$var$load("iZR3N"),
    $a06f67dce68e1116$var$load("jXM1T"),
    $a06f67dce68e1116$var$load("6wr18"),
    $a06f67dce68e1116$var$load("4N1MY"),
    $a06f67dce68e1116$var$load("ffEVr"),
    $a06f67dce68e1116$var$load("4Gdnz"),
    $a06f67dce68e1116$var$load("4UAag"),
    $a06f67dce68e1116$var$load("fwbNS"),
    $a06f67dce68e1116$var$load("zUKwV"),
    $a06f67dce68e1116$var$load("fUeur"),
    $a06f67dce68e1116$var$load("6gMrU"),
    $a06f67dce68e1116$var$load("h4Nf7"),
    $a06f67dce68e1116$var$load("Wowvf"),
    $a06f67dce68e1116$var$load("4g6rd"),
    $a06f67dce68e1116$var$load("5sZTx"),
    $a06f67dce68e1116$var$load("deTdD"),
    $a06f67dce68e1116$var$load("1JeTB"),
    $a06f67dce68e1116$var$load("hhss7"),
    $a06f67dce68e1116$var$load("1sii7"),
    $a06f67dce68e1116$var$load("lnKog"),
    $a06f67dce68e1116$var$load("kT6dz"),
    $a06f67dce68e1116$var$load("aAWLw"),
    $a06f67dce68e1116$var$load("7EorR"),
    $a06f67dce68e1116$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("cMFzX", function(module, exports) {

let $94ea38703e8f44de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $94ea38703e8f44de$var$load("zUKwV"),
    $94ea38703e8f44de$var$load("fUeur"),
    $94ea38703e8f44de$var$load("hUbK8"),
    $94ea38703e8f44de$var$load("9cVML"),
    $94ea38703e8f44de$var$load("1Gr4q"),
    $94ea38703e8f44de$var$load("aGpvE"),
    $94ea38703e8f44de$var$load("fqrmE"),
    $94ea38703e8f44de$var$load("7SteV"),
    $94ea38703e8f44de$var$load("7G12e"),
    $94ea38703e8f44de$var$load("4AElS"),
    $94ea38703e8f44de$var$load("ksOjm"),
    $94ea38703e8f44de$var$load("jAsJw"),
    $94ea38703e8f44de$var$load("jisiR"),
    $94ea38703e8f44de$var$load("icVON"),
    $94ea38703e8f44de$var$load("aLwQm"),
    $94ea38703e8f44de$var$load("bPC3R"),
    $94ea38703e8f44de$var$load("bHb1X"),
    $94ea38703e8f44de$var$load("4x9Jx"),
    $94ea38703e8f44de$var$load("kHXvF"),
    $94ea38703e8f44de$var$load("ea3NB"),
    $94ea38703e8f44de$var$load("iTOzX"),
    $94ea38703e8f44de$var$load("ipkwd"),
    $94ea38703e8f44de$var$load("cvcNg"),
    $94ea38703e8f44de$var$load("iZR3N"),
    $94ea38703e8f44de$var$load("jXM1T"),
    $94ea38703e8f44de$var$load("6wr18"),
    $94ea38703e8f44de$var$load("4N1MY"),
    $94ea38703e8f44de$var$load("ffEVr"),
    $94ea38703e8f44de$var$load("4Gdnz"),
    $94ea38703e8f44de$var$load("4UAag"),
    $94ea38703e8f44de$var$load("1sii7"),
    $94ea38703e8f44de$var$load("6gMrU"),
    $94ea38703e8f44de$var$load("h4Nf7"),
    $94ea38703e8f44de$var$load("Wowvf"),
    $94ea38703e8f44de$var$load("4g6rd"),
    $94ea38703e8f44de$var$load("5sZTx"),
    $94ea38703e8f44de$var$load("deTdD"),
    $94ea38703e8f44de$var$load("1JeTB"),
    $94ea38703e8f44de$var$load("hhss7"),
    $94ea38703e8f44de$var$load("kT6dz"),
    $94ea38703e8f44de$var$load("aAWLw"),
    $94ea38703e8f44de$var$load("7EorR"),
    $94ea38703e8f44de$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("iyWzA", function(module, exports) {

let $d838d65b76e63833$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d838d65b76e63833$var$load("zUKwV"),
    $d838d65b76e63833$var$load("fUeur"),
    $d838d65b76e63833$var$load("hUbK8"),
    $d838d65b76e63833$var$load("9cVML"),
    $d838d65b76e63833$var$load("1Gr4q"),
    $d838d65b76e63833$var$load("aGpvE"),
    $d838d65b76e63833$var$load("fqrmE"),
    $d838d65b76e63833$var$load("7SteV"),
    $d838d65b76e63833$var$load("7G12e"),
    $d838d65b76e63833$var$load("4AElS"),
    $d838d65b76e63833$var$load("ksOjm"),
    $d838d65b76e63833$var$load("jAsJw"),
    $d838d65b76e63833$var$load("jisiR"),
    $d838d65b76e63833$var$load("icVON"),
    $d838d65b76e63833$var$load("aLwQm"),
    $d838d65b76e63833$var$load("bPC3R"),
    $d838d65b76e63833$var$load("bHb1X"),
    $d838d65b76e63833$var$load("4x9Jx"),
    $d838d65b76e63833$var$load("kHXvF"),
    $d838d65b76e63833$var$load("ea3NB"),
    $d838d65b76e63833$var$load("iTOzX"),
    $d838d65b76e63833$var$load("ipkwd"),
    $d838d65b76e63833$var$load("cvcNg"),
    $d838d65b76e63833$var$load("iZR3N"),
    $d838d65b76e63833$var$load("jXM1T"),
    $d838d65b76e63833$var$load("6wr18"),
    $d838d65b76e63833$var$load("4N1MY"),
    $d838d65b76e63833$var$load("ffEVr"),
    $d838d65b76e63833$var$load("4Gdnz"),
    $d838d65b76e63833$var$load("4UAag"),
    $d838d65b76e63833$var$load("6gMrU"),
    $d838d65b76e63833$var$load("h4Nf7"),
    $d838d65b76e63833$var$load("Wowvf"),
    $d838d65b76e63833$var$load("4g6rd"),
    $d838d65b76e63833$var$load("5sZTx"),
    $d838d65b76e63833$var$load("deTdD"),
    $d838d65b76e63833$var$load("1JeTB"),
    $d838d65b76e63833$var$load("hhss7"),
    $d838d65b76e63833$var$load("1sii7"),
    $d838d65b76e63833$var$load("lnKog"),
    $d838d65b76e63833$var$load("kT6dz"),
    $d838d65b76e63833$var$load("aAWLw"),
    $d838d65b76e63833$var$load("7EorR"),
    $d838d65b76e63833$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("dZD8d", function(module, exports) {

let $a2ff538f92442f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a2ff538f92442f53$var$load("zUKwV"),
    $a2ff538f92442f53$var$load("fUeur"),
    $a2ff538f92442f53$var$load("hUbK8"),
    $a2ff538f92442f53$var$load("9cVML"),
    $a2ff538f92442f53$var$load("1Gr4q"),
    $a2ff538f92442f53$var$load("aGpvE"),
    $a2ff538f92442f53$var$load("fqrmE"),
    $a2ff538f92442f53$var$load("7SteV"),
    $a2ff538f92442f53$var$load("7G12e"),
    $a2ff538f92442f53$var$load("4AElS"),
    $a2ff538f92442f53$var$load("ksOjm"),
    $a2ff538f92442f53$var$load("jAsJw"),
    $a2ff538f92442f53$var$load("jisiR"),
    $a2ff538f92442f53$var$load("icVON"),
    $a2ff538f92442f53$var$load("aLwQm"),
    $a2ff538f92442f53$var$load("bPC3R"),
    $a2ff538f92442f53$var$load("bHb1X"),
    $a2ff538f92442f53$var$load("4x9Jx"),
    $a2ff538f92442f53$var$load("kHXvF"),
    $a2ff538f92442f53$var$load("ea3NB"),
    $a2ff538f92442f53$var$load("iTOzX"),
    $a2ff538f92442f53$var$load("ipkwd"),
    $a2ff538f92442f53$var$load("cvcNg"),
    $a2ff538f92442f53$var$load("iZR3N"),
    $a2ff538f92442f53$var$load("jXM1T"),
    $a2ff538f92442f53$var$load("6wr18"),
    $a2ff538f92442f53$var$load("4N1MY"),
    $a2ff538f92442f53$var$load("ffEVr"),
    $a2ff538f92442f53$var$load("4Gdnz"),
    $a2ff538f92442f53$var$load("4UAag"),
    $a2ff538f92442f53$var$load("6gMrU"),
    $a2ff538f92442f53$var$load("h4Nf7"),
    $a2ff538f92442f53$var$load("Wowvf"),
    $a2ff538f92442f53$var$load("4g6rd"),
    $a2ff538f92442f53$var$load("5sZTx"),
    $a2ff538f92442f53$var$load("deTdD"),
    $a2ff538f92442f53$var$load("1JeTB"),
    $a2ff538f92442f53$var$load("hhss7"),
    $a2ff538f92442f53$var$load("1sii7"),
    $a2ff538f92442f53$var$load("lnKog"),
    $a2ff538f92442f53$var$load("eShF9"),
    $a2ff538f92442f53$var$load("kT6dz"),
    $a2ff538f92442f53$var$load("aAWLw"),
    $a2ff538f92442f53$var$load("7EorR"),
    $a2ff538f92442f53$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("gkfdt"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("gkfdt", function(module, exports) {

let $be2a513de0ab94be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be2a513de0ab94be$var$load("1sii7"),
    $be2a513de0ab94be$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.079f089b.js.map
